import type { FieldValidator } from '@lucidtech/las-sdk-browser';
import { memo } from 'react';

import { useComponentStack } from '@/components/core';
import {
  DEFAULT_VALIDATOR_CATEGORY,
  findField,
  NavigationContainer,
  SearchPanel,
  SearchPanelProps,
  ValidatorConfiguration,
  ValidatorMenuItem,
  VALIDATORS,
} from '@/components/ui';
import { useModelConfigStore } from '@/store';
import { generateId } from '@/utils';

export type NewValidatorProps = Omit<SearchPanelProps<FieldValidator>, 'renderItem' | 'searchableCategorizedData'> & {
  fieldId: string;
};

const INewValidator = ({ fieldId, className, ...rest }: NewValidatorProps) => {
  const field = useModelConfigStore((state) => findField(state.fields, fieldId));
  const addValidator = useModelConfigStore((state) => state.addValidator);
  const componentStack = useComponentStack();

  return (
    <SearchPanel
      className={className}
      defaultCategory={DEFAULT_VALIDATOR_CATEGORY}
      placeholder="Search validators"
      renderItem={(item) => (
        <ValidatorMenuItem
          isDisabled={item.comingSoon}
          onAction={() => {
            const validator: FieldValidator = { id: generateId(), ...item };
            addValidator(fieldId, validator, field?.parentId);

            componentStack?.push(
              <NavigationContainer>
                <ValidatorConfiguration fieldId={fieldId} validatorId={validator.id} />
              </NavigationContainer>
            );
          }}
          validator={item}
        />
      )}
      searchableCategorizedData={VALIDATORS}
      {...rest}
    />
  );
};

export const NewValidator = memo(INewValidator) as typeof INewValidator;
